import React from 'react';
import { Trash2, FileAudio, FileText, CheckCircle2, Loader2 } from 'lucide-react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { ScorePill } from './CoachScore';
import { useCoachT } from '../../lib/coachI18n';
import { useAuth } from '../../lib/auth-context';

/* Tab "Valutazioni": storico call analizzate del cliente */
export const CoachCallsList = ({ calls, onOpen, onChanged }) => {
  const { t } = useCoachT();
  const { user } = useAuth();
  const isManager = ['admin', 'amministrativo'].includes(user?.role);

  if (!calls.length) return <div className="text-sm text-muted-foreground py-6 text-center" data-testid="coach-calls-empty">{t('noCalls')}</div>;

  const remove = async (c) => {
    await api.delete(`/coach/calls/${c.id}`);
    onChanged();
  };

  return (
    <div className="divide-y divide-border" data-testid="coach-calls-list">
      {calls.map((c) => {
        const ready = ['ready', 'applied'].includes(c.status);
        return (
          <div key={c.id} className="py-2.5 flex items-center gap-3" data-testid={`coach-call-row-${c.id}`}>
            {c.source === 'audio' ? <FileAudio className="w-4 h-4 text-muted-foreground" /> : <FileText className="w-4 h-4 text-muted-foreground" />}
            {c.evaluation_hidden ? <span className="text-xs text-muted-foreground w-10">—</span> : <ScorePill score={c.score} />}
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{c.analysis?.verdict || c.filename || (c.status === 'error' ? c.error : '…')}</div>
              <div className="text-[11px] text-muted-foreground">{c.user_name} · {(c.created_at || '').slice(0, 16).replace('T', ' ')}</div>
            </div>
            {c.status === 'applied' && <CheckCircle2 className="w-4 h-4 text-emerald-600" title={t('applied')} />}
            {['transcribing', 'analyzing'].includes(c.status) && <Loader2 className="w-4 h-4 animate-spin text-[#8A6D12]" />}
            {ready && <Button size="sm" variant="outline" onClick={() => onOpen(c)} data-testid={`coach-call-open-${c.id}`}>{t('open')}</Button>}
            {(isManager || c.user_id === user?.id) && (
              <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => remove(c)} title={t('delete')} data-testid={`coach-call-delete-${c.id}`}><Trash2 className="w-4 h-4" /></Button>
            )}
          </div>
        );
      })}
    </div>
  );
};
